import React, { useState } from 'react';
import data from '../../data';
import Cart from '../Cart/Cart';
import User from '../User/User';

const Users = () => {
  const allData = data;
  const [users, setUsers] = useState(allData);
  const [cart, setCart] = useState([]);

  const handleAddUser = (user) => {
    console.log('User Added', user.salary);
    const newCart = [...cart, user];
    setCart(newCart);
  };
  return (
    <section className='users'>
      <div className='container'>
        <div className='row'>
          <div className='col-9'>
            <div className='row'>
              {users.map((user) => (
                <User handleAddUser={handleAddUser} user={user}></User>
              ))}
            </div>
          </div>
          <div className='col-3'>
            <Cart cart={cart}></Cart>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Users;
